import { Button, Heading, Input, Slider } from "@RooUI";
import React from "react";

import { useRooTranslation } from "../../../Common/Wrappers/useRooTranslation";
import { FormContainer, FormFieldTwoColumnGrid, FormFields, FormHeader } from "../Common/styles";
import { ButtonContainer } from "../RegistrationPageContainer/styles";

import { useFormContext } from "./RegistrationLocationFormContext";

export const RegistrationLocationForm = () => {
  const {
    onChange,
    onSave,
    loading,
    errors,
    // @ts-expect-error TS2339
    form: { zipcode, travelDistance },
  } = useFormContext();
  const { t } = useRooTranslation();

  return (
    <FormContainer>
      <FormHeader>
        <Heading level={3}>{t("registration.location.title")}</Heading>
      </FormHeader>
      <FormFields>
        <FormFieldTwoColumnGrid>
          <Input
            label="ZIP code"
            inputMode="numeric"
            value={zipcode}
            maxLength={5}
            // @ts-expect-error TS18048
            error={errors["zipcode"]}
            // @ts-expect-error TS2722
            onChange={(e) => onChange("zipcode", e.target.value)}
            name="zipcode"
          />
          <div>
            <Slider
              type="blue"
              label="Travel distance"
              value={travelDistance}
              // @ts-expect-error TS2722
              onChange={(value: number) => onChange("travelDistance", value)}
              tooltip={{ open: true, placement: "bottom", formatter: (v) => `${v} miles` }}
              data-testid="travelDistanceSlider"
            />
          </div>
        </FormFieldTwoColumnGrid>
      </FormFields>
      <ButtonContainer>
        <Button
          $buttonType="primary"
          title="Continue"
          onClick={onSave}
          loading={loading}
          data-testid="locationContinue"
        />
      </ButtonContainer>
    </FormContainer>
  );
};
